/**
 * `ScheduledBadge` — marks a run the SCHEDULER started.
 *
 * Why this exists: recurring jobs (`lexiun-recurring-jobs.md` §3.1) put
 * runs in this pane that the lawyer never asked for — a nightly triage,
 * a watch tick. Without attribution an agent row simply materialises,
 * which reads as the system doing something unrequested and unexplained.
 *
 * Rendered ONLY for `origin === "scheduled"`, which is derived from a
 * source-verified cron session key. `unknown` origins stay deliberately
 * unbadged rather than guessing (see `RunOrigin`).
 */
import { useTranslation } from "react-i18next";
import { CalendarClock } from "lucide-react";

export function ScheduledBadge({ testId }: { testId?: string }) {
  const { t } = useTranslation();
  const label = t("rightSidebar.scheduledBadge");
  return (
    <span
      data-testid={testId}
      title={t("rightSidebar.scheduledBadgeTitle")}
      className="inline-flex shrink-0 items-center gap-0.5 rounded bg-violet-100/70 px-1 py-0.5 text-[9px] font-medium uppercase tracking-wide text-violet-700 dark:bg-violet-950/40 dark:text-violet-300"
    >
      <CalendarClock size={9} aria-hidden />
      {label}
    </span>
  );
}
